import { render, staticRenderFns } from "./Chi.vue?vue&type=template&id=bcb6513c&scoped=true&"
import script from "./Chi.vue?vue&type=script&lang=js&"
export * from "./Chi.vue?vue&type=script&lang=js&"
import style0 from "./Chi.vue?vue&type=style&index=0&id=bcb6513c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb6513c",
  null
  
)

export default component.exports